import dayjs from "dayjs";
import { ActiveTimeEntry, AttachmentFileData, Watchlist } from "shared";

import { immer } from "zustand/middleware/immer";
interface CommonDataState {
  attachmentModalData: {
    attachments: Array<any>;
  };
  perPageCount: {
    ticket: number;
    ping: number;
    timeEntry: number;
    project: number;
    user: number;
    customer: number;
    contract: number;
    recurringInvoice: number;
    archive: number;
    billingProduct: number;
    billingTemplate: number;
    billingTax: number;
    billingExpense: number;
    customerVendor: number;
    customerSites: number;
    customerUserGroup: number;
    location: number;
    tags: number;
    resource: number;
    discount: number;
    readyToBilling: number;
  };
}

interface CommonDataAction {
  resetAllCommonData: () => void;
  resetAttachmentModalData: () => void;
  setAttachmentModalData: (attachments: Array<AttachmentFileData>) => void;
  setPerPageCount: ({
    type,
    count,
  }: {
    type:
      | "ticket"
      | "ping"
      | "timeEntry"
      | "project"
      | "user"
      | "customer"
      | "recurringInvoice"
      | "archive"
      | "contract"
      | "billingTemplate"
      | "billingProduct"
      | "billingTax"
      | "billingExpense"
      | "customerVendor"
      | "customerSites"
      | "customerUserGroup"
      | "location"
      | "tags"
      | "resource"
      | "discount"
      | "readyToBilling";

    count: number;
  }) => void;
}

export interface CommonDataInterface
  extends CommonDataState,
    CommonDataAction {}

export const CommonDataSlice = immer<CommonDataState & CommonDataAction>(
  (set, get) => ({
    attachmentModalData: {
      attachments: [],
    },
    watchListData: [],
    perPageCount: {
      ticket: 100,
      project: 100,
      timeEntry: 100,
      discount: 100,
      ping: 100,
      user: 100,
      customer: 100,
      contract: 100,
      recurringInvoice: 100,
      archive: 100,
      billingTemplate: 100,
      billingProduct: 100,
      billingTax: 100,
      billingExpense: 100,
      customerVendor: 100,
      customerSites: 100,
      customerUserGroup: 100,
      location: 100,
      tags: 100,
      resource: 100,
      readyToBilling: 100,
    },
    setAttachmentModalData(attachments) {
      set((state) => {
        state.attachmentModalData = {
          attachments: attachments,
        };
      });
    },
    resetAllCommonData() {
      set((state) => {
        state.attachmentModalData = {
          attachments: [],
        };
      });
    },
    resetAttachmentModalData() {
      set((state) => {
        state.attachmentModalData = {
          attachments: [],
        };
      });
    },
    setPerPageCount({ type, count }) {
      set((state) => {
        state.perPageCount[type] = count;
      });
    },
  })
);
